module.exports = __webpack_public_path__ + "img/Pattern01.932b8214.png";